<template>
    <v-app-bar>
        <SidebarToggle />

        <v-breadcrumbs
            v-if="!isMobile"
            class="dashboard-header-breadcrumbs"
            :items="breadcrumbItems"
        >
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <FormActions
            v-if="formButtons.length"
            :actions="formButtons"
        />
    </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import SidebarToggle from "./SidebarToggle.vue";
import FormActions from "@/components/forms/FormActions.vue";

export default {
    components: {
        SidebarToggle,
        FormActions,
    },
    computed: {
        ...mapState(["isMobile", "mini_sidebar", "formButtons"]),
        /**
         * Generates the breadcrumb items dynamically based on the current route.
         * Ensures correct translations and fallback values.
         *
         * @returns {Array} - Breadcrumb items for Vuetify breadcrumbs component.
         */
        breadcrumbItems() {
            const route = this.$route;

            const items = [
                {
                    title: this.$t("route.dashboard", "Dashboard"),
                    disabled: false,
                    to: "/dashboard",
                    link: true,
                },
            ];

            if (route.meta?.parent) {
                const parentRouteMap = {
                    "sidebar.trucks": "/dashboard/search-trucks",
                    "sidebar.wares": "/dashboard/search-wares",
                    "sidebar.settings": "/dashboard/company-details",
                    "sidebar.incidents": "/dashboard/my-incidents",
                };

                const parentPath = parentRouteMap[route.meta.parent];
                items.push({
                    title: this.$t(route.meta.parent, route.meta.parent),
                    disabled: false,
                    to: parentPath || "#",
                    link: true,
                });
            }

            if (route.meta?.title) {
                items.push({
                    title: this.$t(route.meta.title, route.meta.title),
                    disabled: true,
                });
            }

            return items;
        },
    },
    methods: {
        /**
         * Emits a global save event to notify the parent component.
         */
        triggerSave() {
            this.$store.commit("REQUEST_SUBMIT");
        },
    },
};
</script>

<style scoped>
.dashboard-header-breadcrumbs :deep(.v-breadcrumbs-item) {
    font-weight: 700 !important;
}
</style>
